import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.scss']
})
export class AgreementComponent implements OnInit {

  constructor(
    private viewportScroller: ViewportScroller,
  ) { }

  ngOnInit(): void {
    this.toTop();
  }
  toTop() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
